import React, { useState, useRef, useEffect } from "react";
import "./OuterFiltersDropDown.css";
import { DownIcon, UpIcon } from "../../components/FilterModal/Icons.tsx";

export default function SuspiciousDropDown({ isSuspicious, setIsSuspicious, filters }) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef();
  const itemRef = useRef();

  // Two filter options
  const options = [
    { label: "All Transactions", value: false },
    { label: "Suspicious", value: true },
  ];

  // Close dropdown when clicking outside
  const handleOutsideClick = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  useEffect(() => {
    if (isOpen && itemRef.current) {
      const activeItem = itemRef.current.querySelector(".active");
      if (activeItem) {
        itemRef.current.scrollTop = activeItem.offsetTop - 72;
      }
    }
  }, [isOpen]);

  const currentLabel =
    isSuspicious === true
      ? "Suspicious"
      : isSuspicious === false
      ? "All Transactions"
      : "Suspicious Filter";

  return (
    <div className="dropdown-wrapper" ref={dropdownRef}>
      <button
        style={{ fontSize: "12.5px" }}
        className={`TransactionsfilterSuspiciousDropDownBtn ${
          filters.isSuspicious !== "" ? "active" : ""
        }`}
        onClick={() => setIsOpen(!isOpen)}
      >
        {currentLabel}
        {!isOpen ? <DownIcon /> : <UpIcon />}
      </button>

      {isOpen && (
        <div className="dropdown-list" ref={itemRef}>
          {options.map((option, index) => (
            <button
              key={index}
              onClick={() => {
                setIsSuspicious(option.value);
                setIsOpen(false);
              }}
              className={`dropdown-item ${
                option.value === isSuspicious ? "active" : ""
              }`}
            >
              {option.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
